import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';
import { HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * <Hint text="...">enfant à survoler</Hint>
 * Enveloppe un élément et affiche une info-bulle explicative au survol.
 * Pédagogique — pour aider les nouveaux utilisateurs à comprendre chaque zone du module.
 */
export function Hint({ text, children, side = 'top', delay = 200, className }) {
    if (!text) return children;
    return (
        <TooltipProvider delayDuration={delay}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className={cn("inline-flex items-center", className)}>{children}</span>
                </TooltipTrigger>
                <TooltipContent side={side} className="max-w-[260px] bg-slate-900 text-white text-[11px] leading-snug px-2.5 py-1.5">
                    {text}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}

/**
 * <InfoHint text="..." /> — Petit "?" circulaire à afficher à côté d'un label.
 * Ne prend pas d'enfant : c'est juste une icône info-bulle.
 */
export function InfoHint({ text, side = 'top', className }) {
    if (!text) return null;
    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        className={cn(
                            "inline-flex items-center justify-center w-3.5 h-3.5 rounded-full text-slate-400 hover:text-indigo-500 cursor-help transition-colors",
                            className
                        )}
                        tabIndex={-1}
                    >
                        <HelpCircle className="w-3.5 h-3.5" />
                    </span>
                </TooltipTrigger>
                <TooltipContent side={side} className="max-w-[280px] bg-slate-900 text-white text-[11px] leading-snug px-2.5 py-1.5">
                    {text}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
